import { Component, OnInit, HostListener, afterNextRender, ViewChild } from '@angular/core';
import { faFilePdf } from '@fortawesome/free-regular-svg-icons';
import { SearchService } from '../shared/services/search.service';
import { ConflictResult } from '../shared/models/conflict-result';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { CreateMatterComponent } from '../create-matter/create-matter.component';
import { GlobalDataService } from '../shared/services/global-data.service';
import { Router, NavigationEnd } from '@angular/router';
import { filter, takeUntil } from 'rxjs/operators';
import { Observable, Subject, firstValueFrom } from 'rxjs';
import { FormControl } from '@angular/forms';
import { CustomSnackbarComponent } from '../custom-snackbar/custom-snackbar.component';
import { UploadDocumentService } from '../shared/services/upload-document.service';
import { CustomSnackbarData } from '../shared/models/custom-snackbar-data';
import { IdNameLookup } from '../shared/lookups/id-name-lookup';
import { SearchPopupComponent } from '../search-popup/search-popup.component';
import { Jurisdiction } from '../shared/models/jurisdiction';

import { FilteringEventArgs } from '@syncfusion/ej2-dropdowns';
import { EmitType } from '@syncfusion/ej2-base';
import { Query } from '@syncfusion/ej2-data';
import { DropDownListComponent } from '@syncfusion/ej2-angular-dropdowns';
import { WaitDialogComponent } from '../shared/dialog/wait-dialog/wait-dialog.component';
import { SnackbarService } from '../shared/services/snackbar.service';
@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrl: './home.component.scss'
})
export class HomeComponent implements OnInit {
    faFilePdf = faFilePdf;
    searchInput: string = '';
    isBtnPdfVisible: boolean = false;
    isBtnCreateMatterVisible: boolean = false;
    showResult: boolean = false;
    showContactResult: boolean = false;
    searchText: string = '';
    searchJurisdiction: string = '';
    searchTerm: string = '';
    showProgress: boolean = false;
    conflictResult: ConflictResult[] = [];
    currentTab: string = "";
    matters: IdNameLookup[] = [];
    filteredMatters: Observable<IdNameLookup[]> | undefined;
    mattersFormControl: FormControl = new FormControl('');
    downloadPdfBtn: boolean = false;
    searchBtn: boolean = true;
    hideTabs: boolean = false;
    searchFields: string[] = [];
    //jurisdictions: Jurisdiction[] = [];
    //jurisdictionList: { [key: string]: Object }[] = [];
    myControl = new FormControl('');
    filteredJurisdictions: Jurisdiction[] = [];
    //selectedJurisdiction: any = null;
    showDropdown: boolean = false;
    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        this.showDropdown = false;
    }


    // TODO: After the standalone Conflict Check tool is implemented and deployed,
    // remove all Conflict Check–related code from this project.

    //@ViewChild('jurisdictionDropdown') jurisdictionDropdown: DropDownListComponent;

    constructor(
        private searchService: SearchService,
        private documentService: UploadDocumentService,
        private snackBar: SnackbarService,
        private dialog: MatDialog,
        public router: Router,
        public globalDataSharing: GlobalDataService,
    ) {
        this.currentTab = globalDataSharing._currentTab;
    }

    // maps the appropriate column to fields property
    public fields: Object = { text: "Name", value: "Id" };

    //Bind the filter event
    //public onFiltering: EmitType<FilteringEventArgs> = (e: FilteringEventArgs) => {
    //    let query = new Query();
    //    query = (e.text != "") ? query.where("Name", "contains", e.text, true) : query;
    //    e.updateData(this.jurisdictionList, query);
    //};


    async ngOnInit() {
        //await firstValueFrom(this.searchService.getAllJurisdictions()).then(data => {
        //    this.jurisdictions = data;
        //    data.forEach((d) => this.jurisdictionList.push({ Id: d.jurisdictionCode, Name: d.jurisdictionName }));

        //    setTimeout(() => {
        //        const orgkey = sessionStorage.getItem("orgkey")!
        //        this.selectedJurisdiction = this.jurisdictions.find(j => j.orgKey == orgkey);
        //        if (this.selectedJurisdiction) {
        //            this.searchService.selectedJurisdiction = this.selectedJurisdiction.jurisdictionCode;
        //            this.jurisdictionDropdown.value = this.selectedJurisdiction.jurisdictionCode;
        //        }
        //    });
        //});

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe(() => {
            this.updateTabFromUrl();
        });
        this.updateTabFromUrl();

        this.searchService.buttonVisible$.subscribe(isVisible => {
            this.isBtnPdfVisible = isVisible;
        });
    }

    updateTabFromUrl() {
        const url = this.router.url;
        if (url.includes('conflictcheck') || sessionStorage.getItem("type")?.toLowerCase() == "conflictcheck") {
            this.globalDataSharing.currentTab = 'ConflictCheck';
            this.showResult = true;
        } else if (url.includes('idverification') || sessionStorage.getItem("type")?.toLowerCase() == "idverification") {
            this.globalDataSharing.currentTab = 'IdVerification';
            this.showContactResult = true;
        }
        else if (url.includes('admin')) {
            this.hideTabs = true;
        }
        this.currentTab = this.globalDataSharing.currentTab;
    }

    //onJurisdictionSelected(jurisdiction: any) {
    //    this.selectedJurisdiction = this.jurisdictions.find(j => j.jurisdictionCode === jurisdiction.Id);
    //    if (this.selectedJurisdiction) {
    //        this.searchService.selectedJurisdiction = this.selectedJurisdiction.jurisdictionCode;
    //        this.search(this.globalDataSharing._currentTab);
    //    }
    //}

    //search(currentTab: string) {
    //    this.conflictResult = [];
    //    this.isBtnPdfVisible = false;
    //    this.downloadPdfBtn = false;
    //    if (currentTab == "ConflictCheck") {
    //        if (this.validateSearchText()) {
    //            if (this.selectedJurisdiction) {
    //                this.searchService.conflictSearchTerm = this.searchText.split(" OR ").map(item => item.trim());
    //                this.showResult = true;
    //                this.searchService.searchClick.next(true);
    //            } else {
    //                this.showProgress = false;
    //                this.snackBar.successSnackBar("Select a Jurisdiction to Search");
    //            }
    //        } else {
    //            this.showProgress = false;
    //            this.snackBar.errorSnackBar("Please enter a valid search term.");
    //            this.searchText = '';
    //        }
    //    }
    //}

    validateSearchText(): boolean {
        if (typeof this.searchText !== "string" || this.searchText.trim() === "") {
            return false;
        }

        // Check if the string contains only spaces and commas
        if (/^[,\s]+$/.test(this.searchText)) {
            return false; // Reject if it contains only spaces and commas
        }

        const allowedPatterns = [
            /^[\x20-\x7E\u0080-\uFFFF]+$/,                       // Any printable ASCII characters
            /^[\x20-\x7E\u0080-\uFFFF]+\*$/,                     // Text* with any printable ASCII characters
            /^".*"$/,                               // "Text" (Quotes can still be used)
            /^[\x20-\x7E\u0080-\uFFFF]+ OR [\x20-\x7E\u0080-\uFFFF]+$/,       // textA OR textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF]+ or [\x20-\x7E\u0080-\uFFFF]+$/,       // textA or textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF]+ AND [\x20-\x7E\u0080-\uFFFF]+$/,      // textA AND textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF]+ and [\x20-\x7E\u0080-\uFFFF]+$/,      // textA and textB with any printable characters
            /^[\x20-\x7E\u0080-\uFFFF\s]+$/,                    // Text with spaces and printable ASCII characters
            /^[\x20-\x7E\u0080-\uFFFF\s]+\*$/,                  // Text with spaces and asterisk with printable ASCII characters
        ];

        for (let index = 0; index < allowedPatterns.length; index++) {
            var isValid = allowedPatterns[index].test(this.searchText);
            if (isValid) {
                return true;
            }
        }
        return false
    }

    //openCreateMatterDialog() {
    //    var dialogRef = this.dialog.open(CreateMatterComponent, {
    //        minWidth: "80vw",
    //        height: "90vh",
    //        disableClose: true,
    //    })
    //}

    //Download PDF to local storage.
    downloadPDF() {
        this.showProgress = true;
        this.searchBtn = false;
        var conflictId = sessionStorage.getItem(`conflictId`)
        if (conflictId) {
            this.documentService.downlaodFile(parseInt(conflictId), "conflict").subscribe(file => {
                this.documentService.saveFile(file);
                //this.downloadPdfBtn = false;
            },
                (error: any) => {
                    this.snackBar.successSnackBar("Failed to generate PDF.");
                }
            )
        } else {
            this.snackBar.successSnackBar("Unable to download PDF. Please try again later.");
        }
        this.showProgress = false;
        this.searchBtn = true;
    }

    async uploadPdf() {
        this.showProgress = true;
        this.searchBtn = false;
        const cancelSubject = new Subject<void>();

        const dialogRef = this.dialog.open(WaitDialogComponent, {
            disableClose: true,
            panelClass: 'wait-dialog-panel',
            data: {
                message: 'Checking for conflicts across all jurisdictions and generating your PDF. This may take a moment...',
                onCancel: () => cancelSubject.next()
            }
        });

        var conflictId = sessionStorage.getItem(`conflictId`);
        const OrgKey = sessionStorage.getItem(`actionStepOrgKey`);
        if (!OrgKey) {
            this.snackBar.warningSnackBar(
                'Org Key not found in the URL. Please navigate to the Conflict Check Tool via Actionstep and try again.'
            );
            this.resetUIState(dialogRef);
            return;
        }

        if (!conflictId) {
            this.snackBar.successSnackBar("Unable to upload PDF. Please try again later.", );
            this.resetUIState(dialogRef);
            return;
        }

        this.documentService.uploadPdf(parseInt(conflictId), "conflict", OrgKey)
            .pipe(takeUntil(cancelSubject))
            .subscribe({
                next: (res) => {
                    const path = sessionStorage.getItem("api-endpoint");
                    const link = `${path}/mym/asfw/workflow/documents/views/action_id/${res.actionDocuments.links.action}#mode=browse&view=list&folder=0&drive=DL`;

                    const customSnackbarData: CustomSnackbarData = {
                        message: `Document "${res.actionDocuments.name}" uploaded to matter no. #${res.actionDocuments.links.action}.`,
                        link: link,
                    };

                    this.snackBar.customSnackBar(customSnackbarData)
                      
                },
                error: (err) => {
                    if (err.name === 'CanceledError') return;

                    const errorMessage = err.error?.exceptions?.[1]?.message || "Upload failed.";
                    this.snackBar.errorSnackBar(errorMessage);

                    if (
                        errorMessage.includes("'Client File' matter not found") ||
                        errorMessage.includes("Download the PDF and upload to the matter in Actionstep manually")
                    ) {
                        this.downloadPdfBtn = true;
                    }

                    this.resetUIState(dialogRef);
                },
                complete: () => {
                    this.resetUIState(dialogRef);
                }
            });
    }


    private resetUIState(dialogRef: MatDialogRef<any>): void {
        this.showProgress = false;
        this.searchBtn = true;
        dialogRef.close();
    }

    openSearchPopup() {
        const dialogRef = this.dialog.open(SearchPopupComponent, {
            maxWidth: '50vw',
            width: '40%',
            panelClass: 'responsive-dialog',
            disableClose: true,
            data: {
                searchText: this.searchText,
                searchFields: this.searchService.conflictSearchTerm.map(() => "").concat("").slice(0, 6)
            }
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.searchText = result;
                this.searchText = result.searchText.join(' OR ');
                this.searchFields = result.searchFields;
            }
        });
    }
}
